<template>
  <div>
    <header class="landing-navbar">
      <div class="landing-container landing-navbar-content">
        <!-- Logo and Brand -->
        <router-link to="/" class="landing-logo">
          <img :src="require('@/assets/sarpamp.png')" alt="SARPA MP Logo" class="landing-logo-img" />
          <span class="landing-logo-text">SARPA<span>MP</span></span>
        </router-link>

        <!-- Navigation Links (Desktop Only) -->
        <ul class="landing-nav-links">
          <li><router-link to="/" class="landing-nav-link" exact>Home</router-link></li>
          <li><router-link to="/p/about-us" class="landing-nav-link">About Us</router-link></li>
          <li><router-link to="/p/mission-vision" class="landing-nav-link">Mission & Vision</router-link></li>
          <li><router-link to="/p/back-story" class="landing-nav-link">Back Story</router-link></li>
        </ul>

              <!-- Action Buttons -->
      <div class="landing-nav-actions" style="gap: 12px;">
        <template v-if="isLoggedIn">
          <v-menu
            offset-y
            left
            nudge-bottom="12"
            transition="slide-y-transition"
            content-class="landing-user-menu"
          >
            <template v-slot:activator="{ attrs, on }">
              <div class="landing-user-chip" v-bind="attrs" v-on="on">
                <span class="landing-user-avatar">{{ userInitial }}</span>
                <span class="landing-user-chip-name">{{ userName }}</span>
                <v-icon size="18" class="landing-user-caret">mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-card class="landing-user-card landing-user-card--menu" elevation="0">
              <div class="landing-user-card-header">
                <span class="landing-user-avatar landing-user-avatar--lg">{{ userInitial }}</span>
                <div class="landing-user-card-info">
                  <span class="landing-user-card-name text-truncate">{{ userName }}</span>
                  <span v-if="roleLabel" class="landing-user-card-role">{{ roleLabel }}</span>
                </div>
              </div>

              <v-divider></v-divider>

              <button type="button" class="landing-user-card-logout" @click="logout">
                <v-icon size="18" color="#e53935">mdi-logout-variant</v-icon>
                Logout
              </button>
            </v-card>
          </v-menu>

          <router-link :to="dashboardPath" class="landing-btn">
            <v-icon left size="18" color="white">mdi-view-dashboard-outline</v-icon>
            Dashboard
          </router-link>
        </template>
        <router-link v-else to="/login" class="landing-btn landing-btn-outline">
          <v-icon left size="18" color="var(--text-main)">mdi-account-lock-outline</v-icon>
          Login
        </router-link>

        <!-- <a href="#" class="landing-btn">
          <v-icon left size="18" color="white">mdi-apple</v-icon>
          App Store
        </a> -->

        <a href="https://play.google.com/store/apps/details?id=com.sarpamp.leopard&hl=en_IN" target="_blank" class="landing-btn">
          <v-icon left size="18" color="white">mdi-google-play</v-icon>
          Play Store
        </a>
      </div>


        <!-- Hamburger Icon (Visible on Mobile/Tablet) -->
        <v-btn icon class="landing-menu-btn" @click="drawer = !drawer">
          <v-icon size="28" color="var(--text-main)">mdi-menu</v-icon>
        </v-btn>
      </div>
    </header>

    <!-- Mobile/Tablet Sidebar Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      right
      width="280"
      class="landing-drawer"
    >
      <div class="landing-drawer-header">
        <span class="landing-logo-text">SARPA<span>MP</span></span>
        <v-btn icon @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      
      <v-divider></v-divider>

      <v-list class="landing-drawer-list">
        <v-list-item to="/" exact class="landing-drawer-item" @click.native="drawer = false">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/p/about-us" class="landing-drawer-item" @click.native="drawer = false">
          <v-list-item-title>About Us</v-list-item-title>
        </v-list-item>
        <v-list-item to="/p/mission-vision" class="landing-drawer-item" @click.native="drawer = false">
          <v-list-item-title>Mission & Vision</v-list-item-title>
        </v-list-item>
        <v-list-item to="/p/back-story" class="landing-drawer-item" @click.native="drawer = false">
          <v-list-item-title>Back Story</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider class="my-4"></v-divider>

     <div class="landing-drawer-actions">
        <template v-if="isLoggedIn">
          <div class="landing-user-card landing-user-card--inline w-100 mb-3">
            <div class="landing-user-card-header">
              <span class="landing-user-avatar landing-user-avatar--lg">{{ userInitial }}</span>
              <div class="landing-user-card-info">
                <span class="landing-user-card-name text-truncate">{{ userName }}</span>
                <span v-if="roleLabel" class="landing-user-card-role">{{ roleLabel }}</span>
              </div>
            </div>
          </div>

          <router-link :to="dashboardPath" class="landing-btn w-100 mb-3" @click.native="drawer = false">
            <v-icon left size="18" color="white">mdi-view-dashboard-outline</v-icon>
            Dashboard
          </router-link>

          <button type="button" class="landing-btn landing-btn-outline landing-logout-btn w-100 mb-3" @click="logout">
            <v-icon left size="18" color="#e53935">mdi-logout-variant</v-icon>
            Logout
          </button>
        </template>
        <router-link v-else to="/login" class="landing-btn landing-btn-outline w-100 mb-3" @click.native="drawer = false">
          <v-icon left size="18">mdi-account-lock-outline</v-icon>
          Login
        </router-link>

        <!-- <a href="#" class="landing-btn w-100 mb-3" @click="drawer = false">
          <v-icon left size="18" color="white">mdi-apple</v-icon>
          App Store
        </a> -->

        <a href="https://play.google.com/store/apps/details?id=com.sarpamp.leopard&hl=en_IN" target="_blank" class="landing-btn w-100" @click="drawer = false">
          <v-icon left size="18" color="white">mdi-google-play</v-icon>
          Play Store
        </a>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getDashboardPath } from '../../jsFunctions/dashboardRoute';

export default {
  name: 'Navbar',
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    userName() {
      return this.$store.state.userName;
    },
    userInitial() {
      const name = this.$store.state.userName;
      return name ? name.trim().charAt(0).toUpperCase() : '?';
    },
    roleLabel() {
      return this.$store.state.mainRole || this.$store.state.userRole || '';
    },
    dashboardPath() {
      return getDashboardPath(this.$store.state.userRole, this.$store.state.mainRole);
    }
  },
  methods: {
    logout() {
      this.drawer = false;
      this.$store.commit('logoutUser', true);
    }
  }
};
</script>
